import React from 'react';

import Image from '@components/image/image.component';

const ProductImageComponent = ({ product: { images: [image], slug }, ...props }) => (
  <Image src={`products/${image}`} alt={`Imagem do produto ${slug}`} placeholder='none' {...props} />
);

export default ProductImageComponent;
